// extracted by mini-css-extract-plugin
module.exports =  {"list":"_93444fe79c--list--EO8rV","item-wrapper":"_93444fe79c--item-wrapper--_btvn","indented":"_93444fe79c--indented--WhqXG","item":"_93444fe79c--item--SZJyk"};